import { LogoutOutlined } from "@ant-design/icons"
import { Flex } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import Images from "../Images"
import { logout } from "../containers/LoginPage/redux/auth.thunks"
import { useAppDispatch } from "../hooks/use-app-dispatch.ts"
import IconWithText from "./Text"

interface LoginHeaderProps {
  withLogout?: boolean
  children?: React.ReactNode
}

const LoginHeader = ({
  withLogout = false,
  children = null
}: LoginHeaderProps) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  return (
    <div style={{ position: "relative", paddingTop: 48, paddingBottom: 24 }}>
      <Flex align={"center"} justify={"center"} gap={16}>
        {/*<img src={Images.logo} alt="Ezbuild Logo" width={32} height={32} />*/}
        <img src={Images.logo} alt="Ezbuild Logo" width={152} height={40} />
      </Flex>
      {children}

      {withLogout && (
        <div
          style={{
            position: "absolute",
            right: "7.77vw",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer"
          }}
        >
          <IconWithText
            text={t("Log out")}
            icon={() => <LogoutOutlined />}
            onClick={() => dispatch(logout({ navigate }))}
          />
        </div>
      )}
    </div>
  )
}

export default LoginHeader
